"use client"
import { StarRating } from "@/components/atoms"
import { Divider } from "@medusajs/ui"
import { formatDistanceToNow } from "date-fns"
import { useTranslate } from "@tolgee/react"
import { ProductReviewListItemProps } from "@/types/review"
import { useDateLocale } from "@/lib/use-date-locale"

export const ProductReviewItem = ({ review }: { review: ProductReviewListItemProps }) => {
  const { t } = useTranslate()
  const dateLocale = useDateLocale()
  return (
    <div className="mb-6 pb-6 border-b border-gray-200 last:border-b-0 flex gap-6">
      <div className="w-1/6 flex-shrink-0">
        <p className="text-sm font-medium text-gray-900 mb-2 truncate">
          {review.customer.first_name} {review.customer.last_name}
        </p>
        <StarRating starSize={12} rate={Number(review.rating.toFixed(1))} />
        <p className="text-xs text-gray-500 mt-2">
          {formatDistanceToNow(new Date(review.created_at), {
            addSuffix: true,
            locale: dateLocale,
          })}
        </p>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm text-gray-700 leading-relaxed break-all whitespace-pre-wrap">
          {review.customer_note}
        </p>
        {review.seller_note && (
          <div className="mt-4 pl-4 border-l-2 border-gray-300 min-w-0">
            <p className="text-sm font-medium text-gray-900">
              {t("product_review.reply_from_seller")}
              <span className="text-gray-500 font-normal ml-2">
                {formatDistanceToNow(new Date(review.updated_at), {
                  addSuffix: true,
                  locale: dateLocale,
                })}
              </span>
            </p>
            <p className="text-sm text-gray-700 mt-2 break-all whitespace-pre-wrap">
              {review.seller_note}
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
